import { LOCALES } from '@marketplace/i18n';

export const descriptionI18n = {
  [LOCALES.ENG]: {
    description_descriptionURL: 'Informational URL',
    description_descriptionLabel: 'Long Description',
    description_descriptionURL_helping_text:'This URL should link to information about your app or company, helping them to better understand and engage with your app.',
    description_preview_img: 'Preview Images',
    description_drop_img: 'Drop image here',
    description_drop_img_or: 'or',
    description_high_resolution_img: 'High resolution images (png, jpg) 1600x1200 or higher recommended. Max 5MB',
    description_max_size: 'Max size 5MB',
    description_max_number: ' Max number - 5 images'
  },
};
